import { render } from "./CreateTardyDetentionForm.vue?vue&type=template&id=21ac1b9a"
import script from "./CreateTardyDetentionForm.vue?vue&type=script&lang=js"
export * from "./CreateTardyDetentionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__